const FIInformation = {
  FI_NAME: "PenFinancial",
  FI_APPLICATION_NAME: "PenFinancial's Online Marketplace",
  FI_VAULT_NAME: "Your Wallet",
  // in the case of Penf we are replacing the email address with an appointment booking URL. See ticket SFE-3260 for details
  FI_EMAIL: "https://penfinancial.coconutcalendar.com/service",
  FI_TEL: "1-866-866-6641",
  FI_CONDITIONS: "https://www.penfinancial.com/legal",
  FI_PRIVACY: "https://www.penfinancial.com/privacy",
  FI_SITE: "https://www.penfinancial.com/",
  FI_CONTACT_US: "https://www.penfinancial.com/contact-us",
  FI_OVERDRAFT_URL: "https://www.penfinancial.com/rates",
  // FI_BENEFICIARY_URL: "needs updating when the time comes",
  FI_SHARE_AMOUNT: "$10",
  // FI_BUSINESS_SHARE_AMOUNT: "needs updating when the time comes",
  // FI_OVERDRAFT_DEFAULT_AMOUNT: "needs updating when the time comes",
  FI_BOOK_APPOINTMENT: "https://penfinancial.coconutcalendar.com/service",
};

export default FIInformation;
